import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-public-footer',
  templateUrl: './public-footer.component.html',
  styleUrls: ['./public-footer.component.css']
})
export class PublicFooterComponent implements OnInit {

  currentYear: number = (new Date()).getFullYear();
  constructor(private router: Router) {
  }

  ngOnInit() {
  }

  goToDiv(divId) {
    var isNotHome = false;
    if (this.router.url !== "/") {
      this.router.navigate(["/"]);
      isNotHome = true;;
    }
    const firstElementWithError = document.querySelector('#' + divId);

    if (firstElementWithError) {
      if (isNotHome === true) {
        setTimeout(() => {
          $('html, body').animate({
            scrollTop: $(firstElementWithError).offset().top - 100
          }, 1000);
        }, 2000);

      } else {
        $('html, body').animate({
          scrollTop: $(firstElementWithError).offset().top - 100
        }, 1000);
      }
    }
  }
}
